import { parseMessageWithCustomArgs } from '@lemoncode/fonk';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var VALIDATOR_TYPE = 'MATCH_FIELD';
var defaultMessage = 'The field must match with {{field}}';
var setErrorMessage = function setErrorMessage(message) {
  return defaultMessage = message;
};

var isDefined = function isDefined(value) {
  return value !== void 0 && value !== null && value !== '';
};

var getValueByCustomArgs = function getValueByCustomArgs(values, _ref) {
  var field = _ref.field;
  return field.split('.').reduce(function (value, key) {
    return value[key];
  }, values);
};

var validate = function validate(value, values, customArgs) {
  return value === getValueByCustomArgs(values, customArgs);
};

var validator = function validator(fieldValidatorArgs) {
  var value = fieldValidatorArgs.value,
      values = fieldValidatorArgs.values,
      _fieldValidatorArgs$m = fieldValidatorArgs.message,
      message = _fieldValidatorArgs$m === void 0 ? defaultMessage : _fieldValidatorArgs$m,
      customArgs = fieldValidatorArgs.customArgs;

  if (!isDefined(customArgs) || !isDefined(customArgs.field)) {
    throw "Must provide valid customArgs: { field: '' } in ValidationSchema";
  }

  if (!isDefined(values) || _typeof(values) !== 'object') {
    throw "Must provide valid \"values\" object";
  }

  var succeeded = !isDefined(value) || validate(value, values, customArgs);
  return {
    succeeded: succeeded,
    message: succeeded ? '' : parseMessageWithCustomArgs(message || defaultMessage, customArgs),
    type: VALIDATOR_TYPE
  };
};

var validator$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setErrorMessage: setErrorMessage,
  validator: validator
});

export { validator$1 as matchField };
